/**
 * BookingDetailSheet — 예약 상세 사이드 패널 (Sheet 래퍼)
 *
 * 내부 콘텐츠는 BookingDetailContent를 사용하여
 * BookingDetailPageV2와 동일한 UI를 제공한다.
 */

import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import type { AppointmentTimeline } from "@/types/appointment";
import BookingDetailContent from "./BookingDetailContent";

interface BookingDetailSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  appointment: AppointmentTimeline | null;
  onDataChange?: () => void;
}

export default function BookingDetailSheet({
  open,
  onOpenChange,
  appointment,
  onDataChange,
}: BookingDetailSheetProps) {
  if (!appointment) return null;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-xl p-0 flex flex-col">
        <SheetTitle className="sr-only">예약 상세</SheetTitle>
        <BookingDetailContent
          appointment={appointment}
          onDataChange={onDataChange}
          onClose={() => onOpenChange(false)}
          containerType="sheet"
        />
      </SheetContent>
    </Sheet>
  );
}
